import React, {useState} from 'react'
import {ModalWin} from "./ModalWin"
import {
    createCookiesOfName,
    objectLang,
} from "../functions"
import {MenuItemClass} from "../components/MenuItemClass"
import {useNavigate} from "react-router-dom";

export const MenuItem = ({data}) => {

    const [allowed, setAllowed] = useState(true)
    const navigate = useNavigate()
    let lang = objectLang().language
    const l = lang.lang
    const [dataModal, setDataModal] = useState({})

    const removeHandler = () => {
        let description
        if (data.item === 'folder') {
            description = lang.modal.warnings.desc.deleteFolder
        } else if (data.item === 'link') {
            description = lang.modal.warnings.desc.deleteLink
        } else if (data.item === 'google-folder') {
            description = lang.modal.warnings.desc.deleteFolder
        } else if (data.item === 'google-file') {
            description = lang.modal.warnings.desc.deleteGoogleFile
        } else {
            description = lang.modal.warnings.desc.deleteNote
        }
        setAllowed(false)
        setDataModal({
            title: lang.modal.warnings.title,
            desc: description,
            btnCancel: lang.modal.warnings.btnCancel,
            btnOK: lang.modal.warnings.btnOK,
            clickOK: `replaceTo /${l}/${data.item}/remove/${data.id}?parent=${data.parent || ''}`,
            clickCancel: 'reload'
        })
    }

    const copyItemHandler = (copyData) => {
        if (data.item === 'folder') {
            createCookiesOfName('copyFolder', copyData)
            document.querySelector('#context-menu-paste-folder').classList.remove('d-none')
        } else if (data.item === 'link') {
            createCookiesOfName('copyLink', copyData)
            document.querySelector('#context-menu-paste-link').classList.remove('d-none')
        } else if (data.item === 'note') {
            createCookiesOfName('copyNote', copyData)
            document.querySelector('#context-menu-paste-note').classList.remove('d-none')
        }
        document.querySelector('#context-menu-clear-buffer').classList.remove('d-none')
    }

    const cutItemHandler = (cutData) => {
        if (data.item === 'folder') {
            createCookiesOfName('cutFolder', cutData)
        } else if (data.item === 'link') {
            createCookiesOfName('cutLink', cutData)
        } else if (data.item === 'note') {
            createCookiesOfName('cutNote', cutData)
        }
        document.querySelector('#context-menu-clear-buffer').classList.remove('d-none')
    }

    if (!allowed) {
        return <ModalWin data={dataModal}/>
    }

    const shareHandler = (data) => {
        console.log(data)
    }

    return (
        <>
            <MenuItemClass
                lang={lang}
                data={data}
                removeHandler={removeHandler}
                copyItemHandler={copyItemHandler}
                cutItemHandler={cutItemHandler}
                shareHandler={shareHandler}
                navigate={navigate}
            />
        </>
    )
}